<template>
    <DRow>
        <DFabs>
            <DFab
                id="btn-save"
                :disabled="disabled"
                icon="content-save"
                :label="$t('common.save')"
                @click="submit"
            />
            <slot name="additional_button" />
            <DFab
                v-if="cancelRoute"
                icon="close"
                color="secondary"
                @click="showConfirmModal"
            />
        </DFabs>

        <DModal
            :show="isModalOpen"
            :title="$t('common.discard_changes_title')"
            :message="$t('common.discard_changes_message')"
            is-error
            is-confirm
            @confirm="handleCancel"
            @close="isModalOpen = false"
        />
    </DRow>
</template>

<script>
export default {
    name: 'DFormControls',
    components: {
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        cancelRoute: {
            type: [String, Boolean],
            default: false
        },
        dirty: {
            type: Boolean,
            default: true
        }
    },
    emits: ['submit', 'submitSecond', 'update:modelValue'],
    data () {
        return {
            isModalOpen: false,
            changeReason: ''
        }
    },
    computed: {
        errors () {
            return this.$page.props.errors
        }
    },
    methods: {
        submit () {
            if (this.isLoading === true) {
                // We are loading something so do make submit availbale till finished
                return
            }

            // We assume the integrating Page does something with this event and may fire an Intertia
            // which will then toggle our loading state based on registered events.
            this.$emit('submit')
        },
        submitSecond () {
            if (this.isInLoadingState === true) {
                // We are loading something so do make submit availbale till finished
                return
            }

            // We assume the integrating Page does something with this event and may fire an Intertia
            // which will then toggle our loading state based on registered events.
            this.$emit('submitSecond')
        },
        showConfirmModal () {
            if (this.dirty) {
                this.isModalOpen = true
            } else {
                this.handleCancel()
            }
        },
        handleCancel () {
            this.$inertia.get(this.cancelRoute)
        },
        updateValue () {
            this.$emit('update:modelValue', this.changeReason)
        }
    }
}
</script>
<style>
.change-reason {
    margin: 0.5rem 0;
}
.change-reason-modal {
    width: 200px !important;
}
</style>
